export const saveFbcToLocalStorage = (queryParams: any) => {
  const fbclid = queryParams.get('fbclid')
  if (!fbclid) return
  const version = 'fb'
  const subdomainIndex = 1
  const creationTime = Date.now()
  const fbc = `${version}.${subdomainIndex}.${creationTime}.${fbclid}`
  localStorage.setItem('_fbc', fbc)
}
